import orderBy from 'lodash/orderBy';

export const tableInitialState = {
	columns: {
		date: {
			id: 'date',
			direction: 'desc',
			position: 'date',
			title: 'Время'
		},
		id: {
			id: 'id',
			direction: 'desc',
			position: 'id',
			title: 'ID'
		},
		sid: {
			id: 'sid',
			direction: 'desc',
			position: 'sid',
			title: 'SID'
		},
		offer: {
			id: 'offer',
			direction: 'desc',
			position: 'offer',
			title: 'Оффер'
		},
		location: {
			id: 'location',
			direction: 'desc',
			position: 'location',
			title: 'Гео/ip'
		},
		contacts: {
			id: 'contacts',
			direction: 'desc',
			position: 'contacts',
			title: 'Данные'
		},
		status: {
			id: 'status',
			direction: 'desc',
			position: 'status',
			title: 'Статус'
		},
		payout: {
			id: 'payout',
			direction: 'desc',
			position: 'payout',
			title: 'Доход'
		}
	},
	sortByColumn: {
		key: 'date',
		direction: 'desc',
		position: 'date'
	},
	detailsIndex: null,
	isPlayed: false
};

export const transformRows = (rows, sortByColumn) => {
	return sortColumns(rows, sortByColumn);
};

const sortColumns = (rows, sortByColumn) => {
	if (!rows) return null;
	if (!sortByColumn) return rows;
	return orderBy(
		rows,
		row => {
			const value = row[sortByColumn.key];
			switch (sortByColumn.key) {
				case 'sid':
					return getSids(row);
				case 'payout':
					return parseFloat(value);
				case 'location':
					return row.country;
				default:
					return value;
			}
		},
		sortByColumn.direction
	);
};

export const getSids = row => {
	const keys = ['sid1', 'sid2', 'sid3', 'sid4', 'sid5'];
	return keys.map(key => row[key]).filter(sid => !!sid).join(':');
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/table/conversions/index.js